<script setup lang="ts">
const { storeConfig } = useStore()
const reviewStats = computed(() => storeConfig.value?.kiyohStats)
</script>

<template>
  <div class="top-header">
    <div class="top-header__container">
      <AppLink
        v-if="reviewStats?.viewReviewUrl"
        class="top-header__reviews"
        :to="reviewStats.viewReviewUrl"
      >
        <ReviewStars
          :rating="(reviewStats.averageRating || 8.9) / 2"
        />
        {{ reviewStats.averageRating || 8.9 }}/10 | {{ reviewStats.numberReviews || 4000 }} klantbeoordelingen
      </AppLink>

      <div class="top-header__opening-hours">
        <AppOpeningHours />
      </div>

      <AppTopLinks class="top-header__links" />
    </div>
  </div>
</template>

<style>
@import url("~layers/app/components/App/TopHeader.css");
</style>
